const EMOJI_SPLIT = /((?:\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*)+)/gu;
const IS_EMOJI = /^(?:\p{Extended_Pictographic}(?:\uFE0F|\u200D\p{Extended_Pictographic})*)+$/u;

// Renders text with any emoji shown at 2x so it reads like a playful sticker.
export function withBigEmojis(text) {
  if (!text) return text;
  return String(text)
    .split(EMOJI_SPLIT)
    .filter((part) => part !== "")
    .map((part, i) => (IS_EMOJI.test(part) ? <span key={i} className="emoji-2x">{part}</span> : part));
}
